<template>
  <div class="rf-config-licenca">
    <template v-if='status !== ""'>
      <RF-Status :cpntStatus='status' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <div class="rf-div-termos">
        <template v-if='arrAceitar !== null && arrAceitar.length > 0'>
          <p><i class="fa fa-arrow-right" aria-hidden="true"></i>Existe <b>{{ arrAceitar.length }}</b>  termo{{ arrAceitar.length > 1 ? 's' : '' }} para {{ arrAceitar.length > 1 ? 'serem' : 'ser' }} aceito.</p>
          <div>
            <p class="rf-titulo-pacote">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              Atenção
            </p>
            <div class="rf-valor-pacote">
              <p>
                Para contratar o Software Rotina Fácil é necessário estar de acordo com o{{ arrAceitar.length > 1 ? 's' : '' }} termo{{ arrAceitar.length > 1 ? 's' : '' }} abaixo:
              </p>

              <p>
                <table class="rf-tabela-aceites">
                  <tr v-for='(aceitar, numAceite) in arrAceitar' :key="numAceite">
                    <td class="rf-buttons">
                      <RF-Toggles :class='"rf-toggles rf-field-tamanho-0"'
                        :cpntStatus='""'
                        :cpntId='"rf-checkbox-termo-lic-de-uso-" + numAceite'
                        :cpntNome='""'
                        :cpntValue='aceitar.toggles'
                        :cpntDisabled='false'
                        :cpntMostrar='true'
                        :cpntMensagem='""'
                        :cpntMensagemTipo='""'
                        :cpntOn='"Concordo"'
                        :cpntOff='"---"'

                        :cpntOnChange='changeToggles'
                      ></RF-Toggles>

                      <!-- <RF-Toggles :id='"rf-checkbox-termo-lic-de-uso-" + numAceite' :on='"Concordo"' :off='"---"' :vToggles='aceitar.toggles' @changeToggles='changeToggles'></RF-Toggles> -->
                    </td>
                    <td class="rf-termos">
                      <a :href='aceitar.termo_link' target="_blank">
                        <i class="fa fa-file-pdf" aria-hidden="true"></i>
                        Abrir termo de licença de uso {{ numAceite + 1 }}
                      </a>
                    </td>
                  </tr>
                </table>
              </p>
            </div>

            <template v-if='arrMensagem.length > 0'>
              <p class="rf-titulo-pacote">
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                Ressaltando as informações de valores descritas no contrato de Licença de Uso.
              </p>
              <div class="rf-valor-pacote">
                <p v-for='(valMsg, index) in arrMensagem' :key="index" v-html='valMsg'></p>
              </div>
            </template>

            <p class="rf-titulo-pacote">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              Valores Rotina Fácil
            </p>
            <div class="rf-valor-pacote valores" v-if="dados !== null && dados.flagRecorrencia === 'n'">
              <!-- :cpntValorLicencaUso="dados.virtual_valor_pacote"
              :cpntQtdeUsuarios="dados.virtual_n_ua"
              :cpntValorUsuarios="dados.valor_ua"
              :cpntQtdeContadorPlus="dados.virtual_n_cnpj_adicional"
              :cpntValorContadorPlus="dados.valor_cnpj_adicional"
              :cpntQtdeArmArquivos="dados.virtual_arm_arquivo_qtde_gb"
              :cpntValorArmArquivos="dados.virtual_arm_arquivo_valor_por_gb"
              :cpntQtdeSincronismo="dados.virtual_sincronizar_qtde"
              :cpntValorSincronismo="dados.virtual_sincronizar_valor"
              :cpntValorDescontoTestando="dados.descontoTestando"
              :cpntTaxaInscricao="dados.virtual_valor_ti"
              :cpntValorTotal="dados.virtual_total"
              :cpntTituloValorMensal="'Licença de uso'" -->
              <App-Tabela-Totais
              :cpntValorLicencaUso="dados.virtual_valor_pacote"
              :cpntQtdeUsuarios="dados.virtual_n_ua"
              :cpntValorUsuarios="dados.valor_ua"
              :cpntQtdeContadorPlus="dados.virtual_n_cnpj_adicional"
              :cpntValorContadorPlus="dados.valor_cnpj_adicional"
              :cpntQtdeArmArquivos="dados.virtual_arm_arquivo_qtde_gb"
              :cpntValorArmArquivos="dados.virtual_arm_arquivo_valor_por_gb"
              :cpntQtdeSincronismo="dados.virtual_sincronizar_qtde"
              :cpntValorSincronismo="dados.valor_sin_clu_adicional"
              :cpntValorDesconto="dados.desconto"
              :cpntTaxaInscricao="dados.virtual_valor_ti"
              :cpntValorTotal="dados.virtual_total"
              
              :cpntBilhetagem="Object.values(dados.bilhetagem)"
              :cpntValorFatura="dados.recorrenciaValorBruto"
              :cpntValorTestando="dados.pacoteValorTestando"
              :cpntValorDescontoTestando="dados.descontoTestando"
              ></App-Tabela-Totais>
              <!-- <p>
                <table>
                  <tr class="titulo">
                    <td colspan="4">
                      Valores licença de uso mensal
                    </td>
                  </tr>
                  <tr class="titulo">
                    <td class='nome'>
                      Tipo
                    </td>
                    <td class='qtde'>
                      Qtde
                    </td>
                    <td class='valor_uni'>
                      Valor Uni.
                    </td>
                    <td class='valor_tot'>
                      Valor Total
                    </td>
                  </tr>
                  <tr>
                    <td class='nome'>
                      Licença de uso
                    </td>
                    <td class='qtde'>
                      ---
                    </td>
                    <td class='valor_uni'>
                      ---
                    </td>
                    <td class='valor_tot'>
                      R$ {{ dados._virtual_valor_pacote }}
                    </td>
                  </tr>
                  <tr>
                    <td class='nome'>
                      Usuário adicional
                    </td>
                    <td class='qtde'>
                      {{ dados.virtual_n_ua }}
                    </td>
                    <td class='valor_uni'>
                      R$ {{ dados._valor_uni_ua }}
                    </td>
                    <td class='valor_tot'>
                      R$ {{ dados._valor_tot_ua }}
                    </td>
                  </tr>
                  <tr v-if="$store.state.token.clu_pcc.indexOf(36) !== -1">
                    <td class='nome'>
                      CNPJ Adicional
                    </td>
                    <td class='qtde'>
                      {{ dados.virtual_n_cnpj_adicional }}
                    </td>
                    <td class='valor_uni'>
                      R$ {{ dados._valor_cnpj_adicional }}
                    </td>
                    <td class='valor_tot'>
                      R$ {{ dados._valor_cnpj_adicional_total }}
                    </td>
                  </tr>
                  <tr v-if="$store.state.token.clu_pcc.indexOf(30) !== -1">
                    <td class='nome'>
                      Arm. Arquivos
                    </td>
                    <td class='qtde'>
                      {{ dados.virtual_arm_arquivo_qtde_gb }} / GB
                    </td>
                    <td class='valor_uni'>
                      R$ {{ dados._virtual_arm_arquivo_valor_por_gb }}
                    </td>
                    <td class='valor_tot'>
                      R$ {{ dados._virtual_arm_arquivo_valor_por_gb_total }}
                    </td>
                  </tr>
                  <tr v-if="$store.state.token.clu_pcc.indexOf(37) !== -1">
                    <td class='nome'>
                      Sincronismo
                    </td>
                    <td class='qtde'>
                      {{ dados.virtual_sincronizar_qtde }}
                    </td>
                    <td class='valor_uni'>
                      R$ {{ dados._virtual_sincronizar_valor }}
                    </td>
                    <td class='valor_tot'>
                      R$ {{ dados._virtual_sincronizar_valor_total }}
                    </td>
                  </tr>
                  <tr v-if="[ '', null, undefined, '0', '0,0', '0,00' ].indexOf(dados.desconto) === -1">
                    <td class='nome'>
                      Desconto
                    </td>
                    <td class='qtde'>
                      ---
                    </td>
                    <td class='valor_uni'>
                      ---
                    </td>
                    <td class='valor_tot'>
                      - R$ {{ dados._desconto }}
                    </td>
                  </tr>
                  <!- 
                  <tr>
                    <td class='nome'>
                      CNPJ Adicional
                    </td>
                    <td class='qtde'>
                      {{ dados.virtual_n_cnpj_adicional }}
                    </td>
                    <td class='valor_uni'>
                      R$ {{ dados._valor_cnpj_adicional }}
                    </td>
                    <td class='valor_tot'>
                      R$ {{ dados._valor_cnpj_adicional_total }}
                    </td>
                  </tr>
                  <tr v-if="[ '', null, undefined, '0', '0,0', '0,00' ].indexOf(dados.desconto) === -1">
                    <td class='nome'>
                      Desconto
                    </td>
                    <td class='qtde'>
                      ---
                    </td>
                    <td class='valor_uni'>
                      ---
                    </td>
                    <td class='valor_tot'>
                      - R$ {{ dados._desconto }}
                    </td>
                  </tr> --


                  <tr>
                    <td colspan="3" class="total_nome">
                      <b>Total mensal: </b>
                    </td>
                    <td class="total_valor">
                      R$ {{ configConLicCalcularTotalMensal }}
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4" class="divisao">
                      &nbsp;
                    </td>
                  </tr>

                  <tr class="titulo">
                    <td colspan="4">
                      Taxas e valores adicionais
                    </td>
                  </tr>

                  <tr>
                    <td class='nome' colspan="3">
                      Taxa Inscrição
                    </td>
                    <td class='valor_tot'>
                      R$ {{ dados._virtual_valor_ti }}
                    </td>
                  </tr>
                </table>

                <!- <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <table>
                  <tr>
                    <td>
                      <b>Taxa Inscrição</b>:
                    </td>
                    <td style="padding-left: 10px;">
                      {{ valSimbolo }} {{ valTax }}<br/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Licença de Uso</b>:
                    </td>
                    <td style="padding-left: 10px;">
                      {{ valSimbolo }} {{ valLic }} / mês<br/>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>Usuário adicional</b>:
                    </td>
                    <td style="padding-left: 10px;">
                      {{ valSimbolo }} {{ valUsu }} / mês<br/>
                    </td>
                  </tr>
                  <tr v-if="valCluCon !== ''">
                    <td>
                      <b>CNPJ adicional</b>:
                    </td>
                    <td style="padding-left: 10px;">
                      {{ valSimbolo }} {{ valCluCon }} / mês<br/>
                    </td>
                  </tr>
                    
                  
                </table>

                 -->
                 <!-- {{ dados }} --
              </p> -->
            </div>

            <br/>

            <p class="rf-titulo-pacote">
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              Confirmação
            </p>
            <div class="rf-valor-pacote">
              <div style="width: 400px; background: #e9e9e9; border-radius: 10px; border: 1px solid #ccc; padding: 15px 20px; text-align: center; margin-bottom: 10px;">
                <p>
                  <i class="fa fa-exclamation-triangle rf-icon-amarelo" aria-hidden="true" style="vertical-align: 0px; font-size: var(--font-base-soma-20);"></i>
                  Informe senha da conta <b>{{ $store.state.token.conta }}</b> abaixo:
                </p>

                <App-Input v-if='inputSenha.tipo === "input"' style="margin-bottom: 0px !important;"
                :cpntStatus="inputSenha.status"
                :cpntNome="''"
                :cpntType='inputSenha.type'
                :cpntValue='inputSenha.value'

                :cpntOnChange="(value) => { onChangePassword(value) }"
                ></App-Input>

                <!-- <RF-Input v-if='inputSenha.tipo === "input"' :class='"rf-inputSenha-tamanho-" + (inputSenha.hasOwnProperty("tamanho") ? inputSenha.tamanho : 0)' style="margin-bottom: 0px !important;"
                  :cpntStatus='inputSenha.status'
                  :cpntId='inputSenha.id'
                  :cpntNome='inputSenha.nome'
                  :cpntValue='inputSenha.value'
                  :cpntType='inputSenha.type'
                  :cpntAutoComplete='inputSenha.autocomplete'
                  :cpntMask='inputSenha.mask'
                  :cpntDisabled='inputSenha.disabled'
                  :cpntMostrar='inputSenha.mostrar'
                  :cpntAutoFocus='inputSenha.autofocus'
                  :cpntMensagem='inputSenha.mensagem'
                  :cpntMensagemTipo='inputSenha.mensagemTipo'
                  :cpntPlaceholder='inputSenha.placeholder'

                  :cpntOnChange='onChangePassword'
                  :ref='"inputSenha"'
                ></RF-Input> -->

                <!-- <RF-Input v-show='true' :vId='pacSenha.id' :valType='"password"' :vNome='""' :gClass='pacSenha.gClass' :vClassInput='pacSenha.class' :vFieldMsg='pacSenha.vFieldMsg' :vFieldValue='pacSenha.value' :vFormFocus='""' :vDisabled='pacSenha.vDisabled' @onChangeValueInput='onChangePassword'></RF-Input> -->
              </div>

              <p style="text-align: left;">
                <RF-Button 
                  :cpntId='"salvar-pacotes"'
                  :cpntStatus='statusBt' 
                  :cpntTexto='"Declaro que li e concordo com todos os termos descritos acima"' 
                  :cpntClass='[ "btn", "btn-primary" ]'
                  :cpntDisabled='disabledBt'
                  :cpntExplica='explicaBt'

                  @onClickButton='onAceitaContrato'
                ></RF-Button>

                <!-- <RF-Button :btClass='"btn btn-primary"' :vStatusButton='vStatusButton' :type='"text"' :text='"Declaro que li e concordo com todos os termos descritos acima"' @onClickButton='onAceitaContrato'></RF-Button> -->
              </p>
            </div>

            <RF-Dialog v-if='booApresentaCadastro'
              :cpntStatus='""'
              :cpntLargura='"760px"'
              :cpntOcultarBotoes="true"
              :cpntTitulo='"Para aceitar o contrato de licença de uso é necessario preencher os campos abaixo."'

              :cpntOnFecharDialog='onAlteraExibicaoCadastro'>
              <template slot='conteudo'>
                <RF-Meu-Cadastro 
                  :cpntFields="[ 'cnpj', 'razao', 'telefone', 'email', 'cep', 'estado', 'cidade', 'endereco', 'numero', 'complemento', 'bairro', 'rep_leg', 'rep_cpf', 'rep_nas' ]" 
                  :cpntApiValid='apiValidMeuCadastro'

                  :cpntFecharCadastro='onAlteraExibicaoCadastro'
                ></RF-Meu-Cadastro>
              </template>
            </RF-Dialog>
          </div>
        </template>

        <template v-else>
          <p class="rf-titulo-pacote">
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            Termos aceitos até o momento.
          </p>
          <div class="rf-valor-pacote">
            <table>
              <tr>
                <td style="width: 400px;">
                  <template v-for='(aAceite, vIndex) in jaceites'>
                    <template v-if='aAceite.hasOwnProperty("updated_at_ptbr") && aAceite.updated_at_ptbr !== ""'>
                      <div :class="'rf-info-principal rf-div-ativada-' + (vAberto === vIndex)" :key="vIndex">
                        <RF-Button 
                          :cpntId='"salvar-pacotes"'
                          :cpntStatus='""' 
                          :cpntTexto='"Aceite do termo realizado em " + aAceite.updated_at_ptbr' 
                          :cpntIcone='"far fa-check-circle rf-termo-icon-status rf-icon-verde"'
                          :cpntClass='[ "btn", "btn-default", ("rf-button-ativado-" + (vAberto === vIndex)) ]'

                          @onClickButton='funApresentarAceite(vIndex)'
                        ></RF-Button>

                        <!-- <RF-Button :btClass='"btn btn-default rf-button-ativado-" + (vAberto === vIndex)' :vStatusButton='""' :type='"left-icon-right-text"' :text='"Aceite do termo realizado em " + aAceite.updated_at_ptbr' iconClass='far fa-check-circle rf-termo-icon-status rf-icon-verde' @onClickButton='funApresentarAceite(vIndex)'></RF-Button> -->
                      </div>
                    </template>
                  </template>
                </td>
                <td v-show='vAberto !== ""'>
                  <template v-if='vAberto !== "" && vAberto !== null'>
                    <div v-if="[ '', null, undefined ].indexOf(jaceites[vAberto].contador_plus) === -1" style="text-align: center; margin: 50px 20px;">
                      <b>LICENÇA DE USO - CONTADOR PLUS</b>
                    </div>
                    <div v-else class="rf-resumo-termo">
                      <div class="rf-valor-pacote">
                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Informações do aceite
                        </div>
                        <div class="rf-termos-campos">
                          <span class="rf-termo-titulo">Código da Licença de Uso: </span><span class="rf-termo-value">{{ jaceites[vAberto]['clu'] }}</span><br/>
                          <span class="rf-termo-titulo">IP do contratante: </span><span class="rf-termo-value">179.184.56.71</span><br/>
                          <span class="rf-termo-titulo">Usuário On-line que realizou o aceite: </span><span class="rf-termo-value">[{{ jaceites[vAberto]['usu_id'] }}] - {{ jaceites[vAberto]['usu_nome'] }}</span><br/>
                          <span class="rf-termo-titulo">Data e hora do aceite: </span><span class="rf-termo-value">{{ jaceites[vAberto]['updated_at_ptbr'] }}</span>
                        </div>
                        <hr/>

                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Informações da empresa
                        </div>
                        <div class="rf-termos-campos">
                          <span class="rf-termo-titulo">Nome Empresa: </span><span class="rf-termo-value">{{ jaceites[vAberto]['nome'] }}</span><br/>
                          <span class="rf-termo-titulo">CNPJ: </span><span class="rf-termo-value">{{ jaceites[vAberto]['cnpj'] }}</span><br/>
                          <span class="rf-termo-titulo">Inscrição Estadual: </span><span class="rf-termo-value">{{ jaceites[vAberto]['ie'] }}</span><br/>
                          <span class="rf-termo-titulo">Inscrição Municipal: </span><span class="rf-termo-value">{{ jaceites[vAberto]['im'] }}</span><br/>
                          <span class="rf-termo-titulo">Telefone: </span><span class="rf-termo-value">{{ jaceites[vAberto]['telefone'] }}</span><br/>
                          <span class="rf-termo-titulo">Estado: </span><span class="rf-termo-value">{{ jaceites[vAberto]['id_estado'] }}</span><br/>
                          <span class="rf-termo-titulo">Cidade: </span><span class="rf-termo-value">{{ jaceites[vAberto]['cidade'] }}</span><br/>
                          <span class="rf-termo-titulo">CEP: </span><span class="rf-termo-value">{{ jaceites[vAberto]['cep'] }}</span><br/>
                          <span class="rf-termo-titulo">Endereço: </span><span class="rf-termo-value">{{ jaceites[vAberto]['endereco'] }}, {{ jaceites[vAberto]['numero'] }} ({{ jaceites[vAberto]['complemento'] }})</span><br/>
                          <span class="rf-termo-titulo">Bairro: </span><span class="rf-termo-value">{{ jaceites[vAberto]['bairro'] }}</span><br/>
                          <span class="rf-termo-titulo">Site: </span><span class="rf-termo-value">{{ jaceites[vAberto]['site'] }}</span><br/>
                          <span class="rf-termo-titulo">Observações: </span><span class="rf-termo-value">{{ jaceites[vAberto]['obs'] }}</span><br/>
                          <span class="rf-termo-titulo">E-mail: </span><span class="rf-termo-value">{{ jaceites[vAberto]['email_cob'] }}</span>
                        </div>
                        <hr/>

                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Informações do Representante Legal
                        </div>
                        <div class="rf-termos-campos">
                          <span class="rf-termo-titulo">Nome:</span><span class="rf-termo-value">{{ jaceites[vAberto]['rep_leg'] }}</span><br/>
                          <span class="rf-termo-titulo">CPF:</span><span class="rf-termo-value">{{ jaceites[vAberto]['rep_cpf'] }}</span><br/>
                        </div>
                        <hr/>

                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Pacotes contratados
                        </div>
                        <div class="rf-termos-campos">
                          <div class="rf-pacotes-contratados">
                            <div v-for="(pac, index) in jaceites[vAberto].arrPacotesSelected" :key="index">
                              <span v-html='pac.pac_nome'></span>
                              <RF-Explica 
                                :cpntId='"rf-info-pac" + index' 
                                :cpntTitle='pac.j_pac_desc'
                              ></RF-Explica>
                            </div>
                          </div>
                        </div>
                        <hr/>

                        <div class="rf-termos-titulo-campos">
                          <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                          Termo aceito
                        </div>
                        <div class="rf-termos-campos">
                          <RF-Button 
                            :cpntId='"salvar-pacotes"'
                            :cpntStatus='""' 
                            :cpntTexto='"Abrir termo aceito"' 
                            :cpntClass='[ "btn", "btn-default" ]'

                            @onClickButton='funAbrirLink(jaceites[vAberto].termo_link, "_blank")'
                          ></RF-Button>

                          <!-- <RF-Button :vStatusButton='""' :type='"text"' :text='"Abrir termo aceito"' @onClickButton='funAbrirLink(jaceites[vAberto].termo_link, "_blank-sem-menu")'></RF-Button> -->
                        </div>
                        <hr/>
                      </div>

                      <br/>
                    </div>
                  </template>
                </td>
              </tr>
            </table>
          </div>
        </template>

      </div>
    </template>
  </div>
</template>

<style scoped>
  .rf-titulo-pacote {
    padding-top: 15px;
    font-weight: bold;
  }
  .rf-valor-pacote {
    padding-left: 15px;    
  }
    .rf-valor-pacote > p {
      text-align: justify;
    }

  .rf-config-licenca {
    padding: 15px 20px 15px 20px !important;
  }

  .rf-loading-form {
    text-align: center;
    padding: 30px 0px 30px 0px;
  }
    .rf-loading-form > svg {
      font-size: var(--font-base-soma-90);
      color: var(--color-base-05);
    }
    .rf-loading-form > div {
      margin-top: 15px;
    }
  /* -------------------------------------- */
  .rf-div-termos {
    padding-top: 15px;
  }
    .rf-div-termos > p > svg {
      margin-right: 5px;
      color: #717171;
    }
    .rf-div-termos > div {
      padding-left: 20px;
      padding-right: 25px;
      clear: both;
    }
    .rf-tabela-aceites > tr {
    }
      .rf-tabela-aceites > tr > td.rf-buttons {
        padding: 5px 0px;

        width: 120px;
        text-align: center;
      }
        .rf-tabela-aceites > tr > td.rf-buttons > .rf-input-group {
          margin-bottom: 0px;
        }
      .rf-tabela-aceites > tr > td.rf-termos {
        padding-left: 5px;
      }
        .rf-tabela-aceites > tr > td.rf-termos > a {
          color: #337ab7;
          text-decoration: none;
        }
        .rf-tabela-aceites > tr > td.rf-termos > a:hover {

        }
          .rf-tabela-aceites > tr > td.rf-termos > a > svg {
            font-size: var(--font-base-soma-20);
            vertical-align: -2px;
          }    

    .rf-valor-pacote > hr {
      margin: 3px 0px 10px 0px;
    }
    .rf-valor-pacote > .rf-termos-titulo-campos {
      font-size: var(--font-base-soma-14);
      font-weight: 500;
      font-style: italic;
    }
      .rf-valor-pacote > .rf-termos-titulo-campos > svg {
        margin-right: 8px;
      }

    .rf-valor-pacote > .rf-termos-campos {
      padding-left: 25px;
    }
      .rf-valor-pacote > .rf-termos-campos > .rf-termo-titulo {
        font-weight: 600;
        margin-right: 5px;
      }
      .rf-valor-pacote > .rf-termos-campos > .rf-termo-value {
      }

    .rf-valor-pacote > table > tr > td {
      vertical-align: top;
    }

    .rf-valor-pacote > table {
      width: 100%;
    }
    .rf-valor-pacote > table > tr > td:nth-last-child(1) {
      background: #fcfdfd;
      border: 1px solid #ccc;
      padding: 15px 0px;

      -webkit-box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
      -moz-box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
      box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
    }
    .rf-valor-pacote > table > tr > td > div > button.rf-button-ativado-true {
      color: var(--color-base-01);
      background-color: #d4d4d4;
      border-color: #8c8c8c;

      background-image: none;
    }

    .rf-pacotes-contratados > div {
      display: inline-block;
      text-align: center;
      background-color: #f2f6f9;
      padding: 5px 10px;
      border-radius: 5px;
      min-width: 100px;
      margin: 5px;
      border: 1px solid #ddd;

      -webkit-box-shadow: 1px 1px 1px 0px rgba(133,133,133,0.4);
      -moz-box-shadow: 1px 1px 1px 0px rgba(133,133,133,0.4);
      box-shadow: 1px 1px 1px 0px rgba(133,133,133,0.4);
    }

    .rf-div-ativada-false {
      padding: 10px 0px 10px 10px;
    }
    .rf-div-ativada-true {
      background: #fcfdfd;
      border: 1px solid #ccc;
      padding: 10px 0px 10px 10px;
      border-right: none;
      position: relative;
      left: 1px;
    }
    .rf-info-principal > button:focus {
      outline: none;
      color: var(--color-base-01);
      background-color: #fff;
      border-color: #ccc;
    }

  .valores > p > table {
    width: 480px;
  }
    .valores > p > table > tr.titulo > td {
      font-weight: bold;
      background: #e9e9e9;
      text-align: center !important;
    }
    .valores > p > table > tr > td {
      border: 1px solid #ccc;
      padding: 3px 5px;
    }
    .valores > p > table > tr > td.nome {
      width: calc(100% - 270px);
      text-align: left;
    }
    .valores > p > table > tr > td.qtde {
      width: 90px;
      max-width: 90px;
      text-align: center;
    }
    .valores > p > table > tr > td.valor_uni {
      width: 90px;
      max-width: 90px;
      text-align: center;
    }
    .valores > p > table > tr > td.valor_tot {
      width: 90px;
      max-width: 90px;
      text-align: right;
    }
    .valores > p > table > tr > td.divisao,
    .valores > p > table > tr > td.total_nome {
      text-align: right;
      border: none !important;
    }
    .valores > p > table > tr > td.total_valor {
      text-align: right;
      font-weight: bold;
    }
</style>

<style>
  div.rf-info-principal > button > svg {
    font-size: var(--font-base-soma-18);
  }
  div.rf-info-principal > button > div {
    display: inline-block;
  }
</style>

<style scoped>
  .rf-cadastro-mask-web {
    z-index: 2700;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #000;
    opacity: .8;
    width: 100%;
    min-height: 100vh;
  }
  .rf-mask-sob-menu {
    z-index: 3500;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #000;
    opacity: .8;
    width: 100%;
    min-height: 75px;
  }
  .rf-cadastro-mask-web ~ .rf-info {
    text-shadow: #fff 0 1px 0;
    color: var(--color-base-01);
    text-decoration: none;
    outline: none;
    text-shadow: hsla(0,0%,100%,.8) 0 1px 0;
    -webkit-tap-highlight-color: transparent;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba(0,0,0,.1);
    -webkit-font-smoothing: antialiased;
    cursor: auto;
    -webkit-user-select: text !important;

    z-index: 2701;
    position: fixed;
    top: 50%;
    left: 50%;
    
    overflow-y: auto;
  }

  @media only screen and (min-height: 781px) {
    .rf-cadastro-mask-web ~ .rf-info {
      height: 600px;
      width: 700px;

      margin-top: -300px;
      margin-left: -350px;
    }
  }

  @media only screen and (max-height: 780px) {
    .rf-cadastro-mask-web ~ .rf-info {
      height: 500px;
      width: 700px;

      margin-top: -240px;
      margin-left: -350px;
    }
  }

  @media only screen and (max-height: 650px) {
    .rf-cadastro-mask-web ~ .rf-info {
      height: 70%;
      width: 700px;

      margin-top: -170px;
      margin-left: -350px;
    }
  }

  @media only screen and (max-height: 500px) {
    .rf-cadastro-mask-web ~ .rf-info {
      height: 60%;
      width: 700px;

      margin-top: -80px;
      margin-left: -350px;
    }
  }
  
  .rf-cadastro-mask-titulo {
    margin: 15px;
    text-align: center;
    background: rgb(233, 233, 233);
    padding: 5px 0px;
  }
</style>

<script>
  import { SESSAO_ATUALIZAR_TOKEN } from '@/assets/js/Sessao.js'

  export default {
    components: {
      'RF-Meu-Cadastro': () => import('@/components/config/cadastro/Meu-Cadastro.vue'),
      'RF-Toggles': () => import('@/components/rf-geral/toggles/RF-Toggles.vue'),
      'RF-Input': () => import('@/components/rf-geral/input/RF-Input.vue'),
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      'App-Tabela-Totais': () => import('@/components/config/Tabela-Totais.vue')
    },
    data: function () {
      return {
        time: '',
        statusBt: '',
        disabledBt: false,
        explicaBt: null,
        status: '',

        aAceite: {},
        aCheckbox: [],
        vContrato: '',
        arrAceitar: [],
        jaceites: [],
        vAberto: '',
        arrMensagem: [],
        arrPacotes: [],
        aceitou: false,

        dados: null,
        valSimbolo: 'R$',
        valLic: '',
        valUsu: '',
        valCluCon: '',
        valTax: '',

        inputSenha: {
          status: '',
          tamanho: 1,
          id: 'rf-pac-password',
          tipo: 'input',
          type: 'password',
          nome: '',
          value: '',
          api: 'senha',
          autofocus: false,
          mensagem: '',
          mensagemTipo: '',
          mostrar: true
        },
        booApresentaCadastro: false,
        apiValidMeuCadastro: {}
      }
    },
    mounted: function () {
      this.getPacotesExistentes()
    },
    methods: {
      getIniciarContrato: function () {
        var self = this

        self.aAceite = {}
        self.aceitou = false

        // SETA O STATUS DE CARREGANDO SELECT
        self.status = 'carregando'

        // CHAMA FUNÇÃO PARA PEGAR OS DADOS NA API
        self.$store.state.comunicaAPI('/subase/termo/get/lic-de-uso', 'GET', null, function (apiSuccess) {
          if (apiSuccess.data.hasOwnProperty('j_aceitar') && (apiSuccess.data.j_aceitar === null || apiSuccess.data.j_aceitar === '')) {
            self.status = { cod: '999', err: 'OPS! Nenhum contrato encontrado para aceitar. Por favor entrar em contato com nosso suporte pelo telefone 41 3076-7488 ou pelo e-mail atendimento@subase.com.br' }
          } else {
            if (apiSuccess.data.hasOwnProperty('j_aceitar') && apiSuccess.data.j_aceitar !== null) {
              self.arrAceitar = apiSuccess.data.j_aceitar

              for (var key1 in self.arrAceitar) {
                self.arrAceitar[key1]['toggles'] = false
              }

              // RETIRA O LOADING DA PAGINA
              self.status = ''

              // CHAMA A FUNÇÃO PARA ATUALIZAR O STATUS DO BUTTON
              self.funVerificaStatusButton()

              // // CHAMA A FUNÇÃO PARA CALCULAR O VALOR DA LICENÇA DE USO
              // self.onUpdateValores()
            }

            if (apiSuccess.data.hasOwnProperty('j_aceites') && apiSuccess.data.j_aceites !== null && apiSuccess.data.j_aceites !== '') {
              self.vAberto = ''
              self.jaceites = []

              for (var key2 in apiSuccess.data.j_aceites) {
                var arrPacotesSelected = []

                for (var kPcc in apiSuccess.data.j_aceites[key2]['clu_pcc']) {
                  var objPacotes = self.arrPacotes.filter(item => item.pac_id === apiSuccess.data.j_aceites[key2]['clu_pcc'][kPcc])

                  if (objPacotes.length >= 0 && objPacotes[0].pac_id !== 1) {
                    arrPacotesSelected.push(objPacotes[0])
                  }
                }

                // ORDENA O VETOR COM OS PACOTES DISPONIVEIS
                arrPacotesSelected = arrPacotesSelected.sort(function (a, b) {
                  return a.pac_nome < b.pac_nome ? -1 : a.pac_nome > b.pac_nome ? 1 : 0
                })

                apiSuccess.data.j_aceites[key2]['arrPacotesSelected'] = arrPacotesSelected
              }

              // RETIRA O LOADING DA PAGINA
              self.status = ''

              // var ordered = {}
              Object.keys(apiSuccess.data.j_aceites).sort().forEach(function (key) {
                self.jaceites.push(apiSuccess.data.j_aceites[key])
              })

              // INVERTE O VETOR
              self.jaceites.reverse()

              // SETA QUAL É O CONTRATO QUE DEVE ABRIR
              self.vAberto = 0
            }
          }
        }, function () {
        })
      },
      onAceitaContrato: function () {
        // COLOCA O BOTÃO COMO LOADING
        this.statusBt = 'carregando'

        // PEGA TODOS OS TERMOS QUE FORAM SELECIONADOS
        var arrAceitar = this.arrAceitar.filter(item => item.toggles === true)

        // ATUALIZA O STATUS DO BOTÃO
        if (arrAceitar.length === this.arrAceitar.length) {
          this.onAceitarContrato()
        } else {
          this.$store.state.msgWarn('WEB [409]: É necessario aceitar todos os termos antes de proceguir.', 'danger')
          this.statusBt = ''
        }
      },
      onAceitarContrato: function () {
        var self = this

        // COLOCA O BOTÃO COMO LOADING
        self.statusBt = 'carregando'

        var formData = {}
        formData['senha'] = self.inputSenha.value
        formData['tipo'] = 'lic-de-uso'

        // CHAMA FUNÇÃO PARA ACEITAR O CONTRATO
        self.$store.state.comunicaAPI('/subase/termo', 'PUT', formData, function () {
          self.status = 'carregando'

          self.aceitou = true

          SESSAO_ATUALIZAR_TOKEN('clu_con', function () {
            setTimeout(function () {
              setTimeout(function () {
                self.$store.state.msgWarn('API [200]: Obrigado por escolher o Software Rotina Fácil. Você receberá um e-mail com o aceite realizado.<br/> Qualquer dúvida entre em contato através do e-mail <a href="mailto:atendimento@subase.com.br">atendimento@subase.com.br</a>.', 'success', 10)
              }, 300)

              // CHAMA A FUNÇÃO PARA ABRIR OS PAGAMENTOS OU RECARREGAR A TELA
              self.configConLicAbrirPagamentos(self.getPacotesExistentes)
            }, 700)
          })
        }, function (apiError) {
          self.status = apiError
        }, function (apiValid, apiStatus) {
          switch (apiStatus) {
            case 409:
              self.$store.state.msgWarn('API [' + apiStatus + ']: ' + apiValid.geralWeb, 'danger')
              break

            default:
              self.onAlteraExibicaoCadastro(apiValid)
              break
          }

          self.statusBt = ''
        })
      },
      funApresentarAceite: function (vIndex) {
        if (this.vAberto === vIndex) {
          this.vAberto = ''
        } else {
          this.vAberto = vIndex
        }
      },
      funAbrirLink: function (vLink, vTarget) {
        this.$store.state.OPEN_PAGE_CS(vLink, vTarget, {}, false)
      },
      funVerificaStatusButton: function () {
        // PEGA TODOS OS TERMOS QUE FORAM SELECIONADOS
        var arrAceitar = this.arrAceitar.filter(item => item.toggles === true)

        if (arrAceitar.length !== this.arrAceitar.length) {
          this.disabledBt = true
          this.explicaBt = {
            mensagem: 'Para continuar é necessário aceitar todos os termos acima.'
          }
        } else if (this.inputSenha.value.length === 0) {
          this.disabledBt = true
          this.explicaBt = {
            mensagem: 'Para continuar preencha a senha de acesso do seu usuário no campo acima.'
          }
        } else {
          this.disabledBt = false
          this.explicaBt = null
        }
      },
      changeToggles: function (value, id) {
        // PEGA O INDEX DO VETOR QUE ESTA SENDO ALTERADO
        var numIndex = Number(id.substring('rf-checkbox-termo-lic-de-uso-'.length))

        // SETA O NOVO VALOR PARA O INDEX INFORMADO
        this.arrAceitar[numIndex]['toggles'] = value

        // CHAMA A FUNÇÃO PARA ATUALIZAR O STATUS DO BUTTON
        this.funVerificaStatusButton()
      },
      getPacotesExistentes: function () {
        var self = this

        // VERIFICA SE DEVE APRESENTAR AS INFORMAÇOES
        self.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])

        // SETA O STATUS DE CARREGANDO SELECT
        self.status = 'carregando'

        self.statusBt = ''
        self.disabledBt = false
        self.aceitou = false
        // self.status = ''

        self.aAceite = {}
        self.aCheckbox = []
        self.vContrato = ''
        self.arrAceitar = []
        self.jaceites = []
        self.vAberto = ''
        self.arrMensagem = []
        self.arrPacotes = []
        self.valValidadeAceite = null

        self.valSimbolo = 'R$'
        self.valCluCon = ''
        self.valLic = ''
        self.valUsu = ''
        self.valTax = ''

        // RESETA TODAS AS MENSAGENS EXISTENTES
        self.arrMensagem = []

        self.$store.state.comunicaAPI('/subase/pacote/get', 'GET', null, function (apiSuccess) {
          var bilhetagem = {}
          for (var valKeyPac in apiSuccess.data) {
            if (self.$store.state.token.clu_pcc.filter(item => item === apiSuccess.data[valKeyPac].pac_id).length > 0) {
              if (apiSuccess.data[valKeyPac].ti_desc !== '' && apiSuccess.data[valKeyPac].ti_desc !== null) {
                self.arrMensagem.push('<b>Taxa Inscrição ' + apiSuccess.data[valKeyPac].pac_nome + '</b>: ' + apiSuccess.data[valKeyPac].ti_desc)
              }

              if (apiSuccess.data[valKeyPac].lu_desc !== '' && apiSuccess.data[valKeyPac].lu_desc !== null) {
                self.arrMensagem.push('<b>Pacote ' + apiSuccess.data[valKeyPac].pac_nome + '</b>: ' + apiSuccess.data[valKeyPac].lu_desc)
              }
            }

            // SALVA OS PACOTES RECEBIDOS
            var arrPacDescricao = JSON.parse(apiSuccess.data[valKeyPac]['j_pac_desc'])

            // ZERA AS DECRIÇÕES RECEBIDAS
            apiSuccess.data[valKeyPac]['j_pac_desc'] = ''

            // SETA OS DADOS DO TOOLTIP
            for (var keyDesc in arrPacDescricao) {
              apiSuccess.data[valKeyPac]['j_pac_desc'] += arrPacDescricao[keyDesc]
              apiSuccess.data[valKeyPac]['j_pac_desc'] += '<br/><br/>'
            }

            // SETA OS PACOTES COM BILHETAGEM
            if ((apiSuccess.data[valKeyPac].contratado === 't' || [ 'd', 'dv' ].indexOf(self.$store.state.token.clu_con) !== -1) && [ '', null, undefined, '0' ].indexOf(apiSuccess.data[valKeyPac].bilhetagem_valor) === -1) {
              bilhetagem['_' + apiSuccess.data[valKeyPac].pac_id] = apiSuccess.data[valKeyPac]
            }
          }

          // RETIRA O LOADING DA PAGINA
          self.status = ''

          self.arrPacotes = apiSuccess.data

          self.dados = apiSuccess
          self.dados.bilhetagem = bilhetagem

          // // FORMATA OS VALORES RECEBIDOS
          // self.dados._virtual_valor_pacote                    = self.configConLicFormatarValores(self.dados.virtual_valor_pacote)
          // self.dados._valor_uni_ua                            = self.configConLicFormatarValores(self.dados.valor_ua)
          // self.dados.valor_tot_ua                             = (Number(self.dados.virtual_n_ua) * Number(self.dados.valor_ua)).toString()
          // self.dados._valor_tot_ua                            = self.configConLicFormatarValores(self.dados.valor_tot_ua)
          // self.dados._valor_cnpj_adicional                    = self.configConLicFormatarValores(self.dados.valor_cnpj_adicional)
          // self.dados.valor_cnpj_adicional_total               = (Number(self.dados.virtual_n_cnpj_adicional) * Number(self.dados.valor_cnpj_adicional)).toString()
          // self.dados._valor_cnpj_adicional_total              = self.configConLicFormatarValores(self.dados.valor_cnpj_adicional_total)
          // self.dados._virtual_valor_ti                        = self.configConLicFormatarValores(self.dados.virtual_valor_ti)
          // self.dados._desconto                                = self.configConLicFormatarValores(self.dados.desconto)
          // self.dados._virtual_arm_arquivo_valor_por_gb        = self.configConLicFormatarValores(self.dados.virtual_arm_arquivo_valor_por_gb)
          // self.dados.virtual_arm_arquivo_valor_por_gb_total   = Number(Number(Number(self.dados.virtual_arm_arquivo_qtde_gb) * (Number(self.dados.virtual_arm_arquivo_valor_por_gb) / 100)).toFixed(2)) * 100
          // self.dados._virtual_arm_arquivo_valor_por_gb_total  = self.configConLicFormatarValores(self.dados.virtual_arm_arquivo_valor_por_gb_total)
          // self.dados._virtual_sincronizar_valor               = self.configConLicFormatarValores(self.dados.virtual_sincronizar_valor)
          // self.dados.virtual_sincronizar_valor_total          = (Number(self.dados.virtual_sincronizar_qtde) * Number(self.dados.virtual_sincronizar_valor)).toString()
          // self.dados._virtual_sincronizar_valor_total         = self.configConLicFormatarValores(self.dados.virtual_sincronizar_valor_total)

          // CHAMA A FUNÇÃO PARA ABRIR OS PAGAMENTOS OU RECARREGAR A TELA
          self.configConLicAbrirPagamentos(self.getIniciarContrato)
        }, function (apiError) {
          // SETA O STATUS DE CARREGANDO SELECT
          self.status = apiError
        })
      },
      // onUpdateValores: function () {
      //   var self = this

      //   self.valTax = '0,00'
      //   self.valLic = '0,00'
      //   self.valUsu = '0,00'
      //   self.valCluCon = '0,00'

      //   self.$store.state.comunicaAPI('/config/cadastro/get', 'GET', null, function (apiSuccess) {
      //     self.valTax = [ '', null, undefined, '0', '0,0', '0,00', 0 ].indexOf(apiSuccess.data.valor_ti) !== -1 ? '0,00' : apiSuccess.data.valor_ti
      //     self.valLic = [ '', null, undefined, '0', '0,0', '0,00', 0 ].indexOf(apiSuccess.data.valor_loc) !== -1 ? '0,00' : apiSuccess.data.valor_loc
      //     self.valUsu = [ '', null, undefined, '0', '0,0', '0,00', 0 ].indexOf(apiSuccess.data.valor_ua) !== -1 ? '0,00' : apiSuccess.data.valor_ua
      //     self.valCluCon = [ '', null, undefined, '0', '0,0', '0,00', 0 ].indexOf(apiSuccess.data.valor_cnpj_adicional) !== -1 ? '' : apiSuccess.data.valor_cnpj_adicional
      //   }, function (apiError) {
      //     // SETA O STATUS DE CARREGANDO SELECT
      //     self.status = apiError
      //   })
      // },
      onChangePassword: function (value) {
        this.inputSenha.value = value

        // CHAMA A FUNÇÃO PARA VERIFICAR O STATUS DO BUTTON
        this.funVerificaStatusButton()
      },
      onAlteraExibicaoCadastro: function (value) {
        this.booApresentaCadastro = !this.booApresentaCadastro

        if (value === 'enviar') {
          this.onAceitarContrato()
        } else {
          this.apiValidMeuCadastro = value
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      // configConLicFormatarValores: function (valor) {
      //   return this.$store.state.FUN_MASK_VALOR('valorMoeda', valor)
      // },
      configConLicAbrirPagamentos: function (callback) {
        var self = this

        if (self.aceitou === true && self.jaceites.length < 1) {
          // FAZ A BUSCA DOS TOTAIS DA VENDA
          self.$store.state.comunicaAPI('/subase/financeiro/get', 'GET', null, function (apiSuccess) {
            if (apiSuccess.hasOwnProperty('pgto_liberado') && apiSuccess.pgto_liberado.indexOf('cartao') !== -1) {
              self.$router.push({ name: 'meus_pagamentos_cartao' })
            } else {
              // self.getIniciarContrato()
              callback()
            }
          }, function (apiError) {
            // SETA O STATUS DE CARREGANDO SELECT
            self.status = apiError
          })
        } else {
          callback()
        }
      }
    },
    computed: {
      // configConLicCalcularTotalMensal: function () {
      //   // SETA O VALOR DO CAMPO
      //   var valor = 0

      //   // VERIFICA SE TEM LICENÇA VALOR LICENÇA DE USO
      //   if ([ '', null, undefined ].indexOf(this.dados._virtual_valor_pacote) === -1) {
      //     valor = Number(this.dados.virtual_valor_pacote)
      //   }

      //   // VERIFICA SE TEM VALORES PARA SOMAR
      //   if ([ '', null, undefined ].indexOf(this.dados) === -1 && [ '', null, undefined ].indexOf(this.dados._valor_tot_ua) === -1) {
      //     // SOMA O VALOR TOTAL DOS USUARIOS
      //     valor += Number(this.dados.valor_tot_ua)

      //     // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
      //     valor += Number(this.dados.valor_cnpj_adicional_total)

      //     // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
      //     valor += Number(this.dados.virtual_sincronizar_valor_total)

      //     // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
      //     valor += Number(this.dados.virtual_arm_arquivo_valor_por_gb_total)
      //   }

      //   if ([ '', null, undefined ].indexOf(this.dados._desconto) === -1) {
      //     valor -= Number(this.dados.desconto)
      //   }

      //   // RETORNA O VALOR CALCULADO E FORMATADO
      //   return this.configConLicFormatarValores(valor)
      // }
    }
  }
</script>
